import { submit } from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import * as $ from 'jquery';
import { orderEditCancel, orderUpdate } from '../../../redux/actions/order/orderActions';
import OrderForm from '../order/OrderForm';
import { useEffect } from 'react';

function OrderModal(props) {
  const { order, orderEditing } = props;
  const dispatch = useDispatch()

  useEffect(() => {
    if (!orderEditing) {
      $('#orderForm-modal').modal('hide');
    }
  }, [orderEditing])

  const handleRemoteSubmit = (formName) => {
    dispatch(submit(formName))
  }

  const handleOrderSubmit = (data) => {
    data = validateArr(data)
    dispatch(orderUpdate(data, { include: '*' }))
  }

  const validateArr = (data) => {
    // eliminate lens_types_attributes empty obj as per BE requirement
    let eyeglasses_attributes = data.eyeglasses_attributes?.map(item => {
      let lensAttribute = item.lens_types_attributes?.filter(lens => lens.settings_eyeglass_lens_type_id)
      return { ...item, lens_types_attributes: lensAttribute ?? [] }
    })
    return { ...data, eyeglasses_attributes: eyeglasses_attributes }
  }

  const handleOrderEditCancel = () => {
    dispatch(orderEditCancel())
  }

  return (
    <div className="exam-setting-modal exam-modal">
      <div className="modal fade" id="orderForm-modal" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
        <div className="modal-dialog m-0" role="document">
          <div className="modal-content bg-light">
            {order.id &&
              <OrderForm
                onSubmit={handleOrderSubmit}
                onRemoteSubmit={handleRemoteSubmit}
                handleOrderEditCancel={handleOrderEditCancel}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const { order } = state;
  return {
    order: order.order,
    orderEditing: order.editing
  };
}

export default connect(mapStateToProps)(OrderModal);